import toast from 'react-hot-toast';
import Swal from 'sweetalert2';

export const toastr = {
  success: (title, message) => {
    const text = message ? `${title}: ${message}` : title;
    toast.success(text);
  },
  error: (title, message) => {
    const text = message ? `${title}: ${message}` : title;
    toast.error(text);
  },
  warning: (title, message) => {
    const text = message ? `${title}: ${message}` : title;
    toast(text, { icon: '⚠️' });
  },
  info: (title, message) => {
    const text = message ? `${title}: ${message}` : title;
    toast(text, { icon: 'ℹ️' });
  },
  confirm: (message, options = {}) => {
    const { onOk, onCancel } = options;
    const isDarkMode = document.documentElement.getAttribute('data-bs-theme') === 'dark';
    Swal.fire({
      title: 'Are you sure?',
      text: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
      background: isDarkMode ? '#212529' : '#fff',
      color: isDarkMode ? '#fff' : '#000',
    }).then((result) => {
      if (result.isConfirmed) {
        onOk?.();
      } else {
        onCancel?.();
      }
    });
  },
};
